import type { PropsWithChildren } from 'react';

import { twJoin } from 'tailwind-merge';

type Props = PropsWithChildren<{
  label: string;
  noPadding?: boolean;
}>;

export default function PreferenceRow({
  label,
  noPadding = false,
  children,
}: Props): React.ReactElement {
  const className = twJoin('pb-2', noPadding ? 'pb-0' : '');

  return (
    <tr>
      <td className={className}>{label}</td>
      <td className={className}>
        <div className="flex justify-end w-full">{children}</div>
      </td>
    </tr>
  );
}
